/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export const SHOWS_AND_MOVIES_SCREEN_ID: string = "/screens/showsAndMovies";
export const SHOWS_AND_MOVIES_SCREEN_NAME: string = "Shows & Movies";
export const SHOWS_AND_MOVIES_API_ENDPOINT: string =
  "/v4/showsAndMovies/carousels";
export const SHOWS_AND_MOVIES_CONTENT_HIGHLIGHT_DWELL_MS: number = 500;
